export const reasonOptions = [
  // {text: 'Feedback/Customer Care', value: 'feedback'},
  // {text: 'Report an issue', value: 'issue'},
  {text: 'Account Help', value: 'Account Help'},
  {text: 'Report an issue', value: 'Report an issue'},
  {text: 'Question', value: 'Question'},
  {text: 'Other', value: 'Other'},
]